import Meta from "../../components/custom-ui/meta/Meta";
import AcademyProgramCard from "../../components/seeker/academy/AcademyProgramCard";
import {
  sortAcademyListings,
  usePublishedAcademyListings,
} from "../../data/academyListings";
import WedgeSpinner from "../../components/spinners/wedges-spinner";
import { requireAuth } from "../../providers/auth";

function SeekerAcademyProgramsPage() {
  const { data, isLoading } = usePublishedAcademyListings();
  const programs = sortAcademyListings(Array.isArray(data) ? data : []);

  return (
    <>
      <Meta title="Academy" />
      <div
        className="box-border h-screen max-h-screen overflow-x-hidden overflow-y-auto overscroll-y-contain pt-[160px]"
        style={{ background: "rgb(244, 247, 248)" }}
      >
        <div className="mx-auto w-full max-w-[1608px] px-12 py-6 xs:px-3 sm:px-1 md:px-10 md:pb-10 md:pt-9 lg:px-[60px]">
          <div className="mx-auto mb-10 max-w-[900px] text-center md:mb-12">
            <p className="text-[13px] font-semibold uppercase tracking-[0.14em] text-[#5E7A8D]">
              Instant Teams Academy
            </p>
            <h1 className="mb-2 font-sans text-[36px] font-extrabold leading-[1.1] text-instant-teams-blue-Main">
              Growth Starts Here
            </h1>
            <p className="mx-auto m-0 max-w-[760px] font-sans text-[16px] font-medium leading-[1.4] text-instant-teams-tags-TEAL">
              Explore programs designed to support career growth for
              military-connected and remote professionals.
            </p>
          </div>

          {isLoading ? (
            <div className="flex justify-center py-16">
              <WedgeSpinner />
            </div>
          ) : programs.length === 0 ? (
            <p className="py-16 text-center text-sm text-gray-500">
              No academy programs are available right now.
            </p>
          ) : (
            <div className="mx-auto grid w-full max-w-[1200px] grid-cols-1 gap-5 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3 md:gap-6">
              {programs.map((program) => (
                <AcademyProgramCard key={program.id} program={program} />
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default requireAuth(SeekerAcademyProgramsPage);
